export class FavoriteModel {
  public total!:number;
  constructor(data: {}) {
    if (data === undefined || data === null || data === '') {return; }
    Object.assign(this, data);
  }

}
